import React from 'react';
interface MarkdownRendererProps {
  content: string;
}
export const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({
  content
}) => {
  // Simple markdown parser for basic formatting
  const parseMarkdown = (text: string) => {
    const lines = text.trim().split('\n');
    const elements: JSX.Element[] = [];
    let listItems: string[] = [];
    let inList = false;
    const flushList = () => {
      if (listItems.length > 0) {
        elements.push(<ul key={`list-${elements.length}`} className="list-disc list-inside mb-4 space-y-2" data-id="element-71">
            {listItems.map((item, i) => <li key={i} className="text-text-primary" data-id="element-72">
                {item}
              </li>)}
          </ul>);
        listItems = [];
        inList = false;
      }
    };
    lines.forEach((line, index) => {
      // Skip empty lines
      if (!line.trim()) {
        flushList();
        return;
      }
      // Headers
      if (line.startsWith('# ')) {
        flushList();
        elements.push(<h1 key={index} className="text-4xl font-bold mb-6 mt-8 text-text-primary" data-id="element-73">
            {line.substring(2)}
          </h1>);
      } else if (line.startsWith('## ')) {
        flushList();
        elements.push(<h2 key={index} className="text-3xl font-bold mb-4 mt-6 text-text-primary" data-id="element-74">
            {line.substring(3)}
          </h2>);
      } else if (line.startsWith('### ')) {
        flushList();
        elements.push(<h3 key={index} className="text-2xl font-bold mb-3 mt-4 text-text-primary" data-id="element-75">
            {line.substring(4)}
          </h3>);
      }
      // List items
      else if (line.trim().startsWith('- ')) {
        inList = true;
        listItems.push(line.trim().substring(2));
      }
      // Numbered lists
      else if (/^\d+\.\s/.test(line.trim())) {
        inList = true;
        listItems.push(line.trim().replace(/^\d+\.\s/, ''));
      }
      // Bold text
      else if (line.includes('**')) {
        flushList();
        const parts = line.split('**');
        const content = parts.map((part, i) => i % 2 === 1 ? <strong key={i} className="font-bold text-primary" data-id="element-76">
              {part}
            </strong> : part);
        elements.push(<p key={index} className="mb-4 leading-relaxed text-text-primary" data-id="element-77">
            {content}
          </p>);
      }
      // Regular paragraph
      else {
        flushList();
        elements.push(<p key={index} className="mb-4 leading-relaxed text-text-primary" data-id="element-78">
            {line}
          </p>);
      }
    });
    flushList();
    return elements;
  };
  return <div className="prose prose-lg max-w-none" data-id="element-79">{parseMarkdown(content)}</div>;
};